import { useKnowledgeDocumentUXContext } from 'features/knowledgeDocumentViewer/contexts/KnowledgeDocumentUXContext'
import { type MinimapPreference } from 'features/knowledgeDocumentViewer/utils/viewerPreferencesStorage'
import { useCallback } from 'react'

interface UseMinimapPreferenceParams {
  isZoomed: boolean
  isContentReady: boolean
}

function nextMinimapPreference(prev: MinimapPreference): MinimapPreference {
  return prev === 'dismissed' ? 'auto' : 'dismissed'
}

function shouldShowMinimap(
  preference: MinimapPreference,
  isZoomed: boolean,
  isContentReady: boolean
): boolean {
  return preference !== 'dismissed' && isZoomed && isContentReady
}

/** Viewer-wide minimap opt-out. Shown while zoomed unless the user dismissed it. */
export function useMinimapPreference({
  isZoomed,
  isContentReady,
}: UseMinimapPreferenceParams) {
  const { minimapPreference, setMinimapPreference } =
    useKnowledgeDocumentUXContext()

  const toggleMinimap = useCallback(() => {
    setMinimapPreference(nextMinimapPreference)
  }, [setMinimapPreference])

  return {
    showMinimap: shouldShowMinimap(minimapPreference, isZoomed, isContentReady),
    isMinimapEnabled: minimapPreference !== 'dismissed',
    toggleMinimap,
  }
}
